export interface AlertPolicy { failuresBeforeAlert: number; retryAttempts: number; retryDelaySeconds: number }
export type AlertPolicyOverride = { [K in keyof AlertPolicy]?: AlertPolicy[K] | undefined };
export interface PolicyMonitor { tester: string; alertPolicy?: AlertPolicyOverride | null | undefined; frequencyMinutes?: number | null; config?: Record<string, unknown> }
export const testerCapabilities = (tester: string) => ({
  retries: ['Http\\SiteUp', 'HttpSiteUp', 'Http\\IverPublicContent', 'Dns\\Record', 'Whm\\BandwidthUsage', 'Whm\\ResellerAccountsStorageUsage', 'Whm\\StorageUsage'].includes(tester),
  sourceResults: tester.startsWith('Sentry\\'),
});
export const defaultFrequencyMinutes = (tester: string): number => {
  if (['Http\\SiteUp', 'HttpSiteUp', 'Http\\IverPublicContent'].includes(tester)) return 12;
  if (tester.startsWith('Whm\\')) return 1440;
  if (tester.startsWith('Sentry\\')) return 360;
  return 30;
};
const defaultFailureThreshold = (monitor: PolicyMonitor): number => {
  if (monitor.tester !== 'Sentry\\ResticProBackup') return 1;
  const legacy = Number(monitor.config?.backup_consecutive_failures_before_alarm);
  return Number.isInteger(legacy) && legacy >= 1 && legacy <= 100 ? legacy : 2;
};
const boundedInteger = (value: unknown, fallback: number, min: number, max: number): number => Number.isInteger(value) && Number(value) >= min && Number(value) <= max ? Number(value) : fallback;
export const effectiveAlertPolicy = (monitor: PolicyMonitor): AlertPolicy => ({
  failuresBeforeAlert: boundedInteger(monitor.alertPolicy?.failuresBeforeAlert, defaultFailureThreshold(monitor), 1, 100),
  retryAttempts: testerCapabilities(monitor.tester).retries ? boundedInteger(monitor.alertPolicy?.retryAttempts, 2, 0, 10) : 0,
  retryDelaySeconds: boundedInteger(monitor.alertPolicy?.retryDelaySeconds, 60, 1, 900),
});
